import axios from 'axios';
import { API_BASE_URL } from '../../config/apiConfig';

const base = API_BASE_URL;

// Legacy /Accounts/ShareCapitalUpdation + /Accounts/ShareCreationDetails (creation pages).

/** Current capital details (legacy Reports/Viewcapitalinfo → ViewCapitalDetails) */
export const getCapitalDetails = () =>
    axios.get(`${base}/Accounts/GetCapitaldetails`);

/** spSaveShareCapitalData → 'Submited$<file name>' (file name only when Filechk = 'Yes') */
export const saveShareCapitalData = (payload) =>
    axios.post(`${base}/Accounts/SaveShareCapitalData`, payload, { headers: { 'Content-Type': 'application/json' } });

/** ESOP share creation → 'Submited$<file name>' */
export const saveShareCreationData = (payload) =>
    axios.post(`${base}/Accounts/SaveShareCreationData`, payload, { headers: { 'Content-Type': 'application/json' } });
